var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.013,
    height: 31.985,
    viewBox: "0 0 32.013 31.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.001 -0.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set",
    transform: "translate(-360 -774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tag-2",
    d: "M390.1,789.321a3.2,3.2,0,0,1-1,1.818l-10.272,10.239L365.634,788.2l10.256-10.223a3.314,3.314,0,0,1,1.751-1.071h11.5a.957.957,0,0,1,.958.955v11.463ZM375.89,804.3a2.082,2.082,0,0,1-2.935,0l-10.271-10.241a2.061,2.061,0,0,1,0-2.924l1.482-1.479,13.175,13.2L375.89,804.3ZM390.1,774.993H376.683c-1.059,0-1.252.462-2.261,1.518l-13.2,13.165a4.127,4.127,0,0,0,0,5.85l10.27,10.241a4.16,4.16,0,0,0,5.869,0L390.563,792.6c.849-.848,1.451-1.27,1.451-2.326V776.9a1.915,1.915,0,0,0-1.917-1.91Zm-6.138,11.026a2.072,2.072,0,1,1,0-2.926,2.082,2.082,0,0,1,0,2.926Zm-4.4-4.389a4.144,4.144,0,1,0,5.869,0,4.128,4.128,0,0,0-5.869,0Z",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.d588d049191dc032cfa19e80ca4ef42e.svg";
export { ForwardRef as ReactComponent };